import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const scheduleItems = [
  {
    tag: 'Cobertura',
    title: 'Cobertura Integral TNO',
    subtitle:
      'Tecnología, entrevistas previas, producción en sitio, difusión en red y acompañamiento editorial para los 2 días del evento.',
    investment: 450,
  },
  {
    tag: 'Host',
    title: 'Pedro Scutaro',
    subtitle:
      'Conducción, entrevistas en campo, recorrido por stands y presencia de marca durante los 2 días de Expo Mascotas Caracas (fee especial: $120/día).',
    investment: 240,
  },
];

const TOTAL_COBERTURA_HOST = 690; // 450 + 240
const TOTAL_CONTENIDO_PRENSA = 300; // paquete contenido escrito y prensa
const TOTAL_INVERSION = TOTAL_COBERTURA_HOST + TOTAL_CONTENIDO_PRENSA; // 990

const InversionSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Arquitectura de Inversión
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Estrategia comunicacional 360° para el evento
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {scheduleItems.map((item, i) => (
          <Grid item xs={12} key={i} data-aos="fade-up">
            <Box
              component={Card}
              display="flex"
              flexDirection={{ xs: 'column', md: 'row' }}
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': { transform: 'translateY(-4px)', boxShadow: 4 },
              }}
            >
              <Box
                minWidth={{ md: 180 }}
                minHeight={{ xs: 120, md: 'auto' }}
                color={theme.palette.primary.contrastText}
                bgcolor={theme.palette.primary.main}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h4" fontWeight={900}>
                  ${item.investment}
                </Typography>
              </Box>
              <CardContent sx={{ flex: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
                  <Box
                    sx={{
                      px: 1.5,
                      py: 0.5,
                      color: 'white',
                      bgcolor: theme.palette.primary.dark,
                      borderRadius: 1,
                    }}
                  >
                    <Typography variant="caption" fontWeight={700}>
                      {item.tag}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mt: 1 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" variant="body2">
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Box
            component={Card}
            sx={{
              bgcolor: theme.palette.primary.main,
              color: theme.palette.common.white,
              borderLeft: 4,
              borderColor: theme.palette.primary.dark,
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                <Typography variant="h6" fontWeight={700} sx={{ color: theme.palette.common.white }}>
                  INVERSIÓN TOTAL UNIFICADA (Cobertura + Host)
                </Typography>
                <Typography variant="h5" fontWeight={900} sx={{ color: theme.palette.common.white }}>
                  ${TOTAL_COBERTURA_HOST}
                </Typography>
              </Box>
            </CardContent>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            component={Card}
            sx={{
              bgcolor: theme.palette.grey[700],
              color: theme.palette.common.white,
              borderLeft: 4,
              borderColor: theme.palette.grey[900],
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                <Typography variant="h6" fontWeight={700} sx={{ color: theme.palette.common.white }}>
                  + Paquete contenido escrito y prensa
                </Typography>
                <Typography variant="h5" fontWeight={900} sx={{ color: theme.palette.common.white }}>
                  ${TOTAL_CONTENIDO_PRENSA}
                </Typography>
              </Box>
            </CardContent>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            component={Card}
            sx={{
              bgcolor: theme.palette.primary.dark,
              color: theme.palette.common.white,
              borderLeft: 4,
              borderColor: theme.palette.common.white,
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                <Typography variant="h6" fontWeight={700} sx={{ color: theme.palette.common.white }}>
                  TOTAL INVERSIÓN (Cobertura + Host + Contenido y prensa)
                </Typography>
                <Typography variant="h4" fontWeight={900} sx={{ color: theme.palette.common.white }}>
                  ${TOTAL_INVERSION}
                </Typography>
              </Box>
            </CardContent>
          </Box>
        </Grid>
      </Grid>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InversionSection;
